import { Card, CardProps } from '@mantine/core';
import {
  ForwardRefExoticComponent,
  MouseEventHandler,
  RefAttributes,
  forwardRef,
} from 'react';

import classNames from './Card.module.scss';

export type ICardProps = CardProps & {
  onClick?: MouseEventHandler<HTMLDivElement>;
};

/**
 * @deprecated This component wraps Mantine's Card and will be replaced by a new Card component in the v2 design system folder. Please avoid new usages.
 */
export const ZorroCard = forwardRef<HTMLDivElement, ICardProps>(
  ({ withBorder = true, shadow, padding = 'xl', ...props }, ref) => {
    return (
      <Card
        ref={ref}
        withBorder={withBorder}
        classNames={classNames}
        shadow={shadow}
        padding={padding}
        {...props}
      />
    );
  }
) as ForwardRefExoticComponent<ICardProps & RefAttributes<HTMLDivElement>> & {
  Section: typeof Card.Section;
};

ZorroCard.displayName = 'ZorroCard';
ZorroCard.Section = Card.Section;
